export default "/images/vendor/flag-icon-css/flags/1x1/us.svg?2b96179241e072f75ba926d25fe49309";